import { createContext, useContext } from "react";
import styles from "./PartnerShell.module.scss";

export interface PartnerShellProps {
  children: React.ReactNode;
  onLogout: () => void;
}

const PartnerShellContext = createContext<{ onLogout: () => void }>({ onLogout: () => {} });

/** Sign out from inside the partner view — the only action the partner has (the spec's profile menu). A no-op outside the
 *  shell, so a screen rendered alone in a test needs nothing mounted. */
export function usePartnerLogout(): () => void {
  return useContext(PartnerShellContext).onLogout;
}

/**
 * PartnerShell — the partner view's frame (ART-239 part 2; the UI says "partner"). CHROMELESS, per the spec: no app
 * header, no tab bar, no navigation — the partner is server-confined to this one surface, so there is nowhere to go. The
 * screen draws its own top bar (date, mark, greeting, the profile menu with Sign out), which is why the shell only
 * hands it the sign-out. One column at phone width, centred on a wider screen: the spec is mobile-first and a
 * laptop gets the same layout rather than a blocked page (product owner, 2026-10-08).
 */
export function PartnerShell({ children, onLogout }: PartnerShellProps) {
  return (
    <PartnerShellContext.Provider value={{ onLogout }}>
      <main className={styles.shell}>
        <div className={styles.column}>{children}</div>
      </main>
    </PartnerShellContext.Provider>
  );
}
